import {
  FETCH_NOTIFICATIONS,
  NotificationsActionTypes,
  FETCH_NOTIFICATIONS_ERROR,
  FETCH_NOTIFICATIONS_SUCCESS,
} from '../../types/actions/Notifications.action';
import {INotifications} from '../../types/models/Notifications';

export interface NotificationsState {
  data: INotifications[];
  isLoading: boolean;
}

const initialExchanges: NotificationsState = {
  data: [],
  isLoading: true,
};

export default (state = initialExchanges, action: NotificationsActionTypes) => {
  switch (action.type) {
    case FETCH_NOTIFICATIONS:
      return {...state, isLoading: true};

    case FETCH_NOTIFICATIONS_SUCCESS:
      return {...state, isLoading: false, data: action.payload};

    case FETCH_NOTIFICATIONS_ERROR:
      return {...state, isLoading: false};

    default:
      return state;
  }
};
